import React from "react";
//import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import "./Layout.scss";
import Navigation from "./Navigation";
import { Box } from "@mui/material";

function Layout() {
	return (
		<Box sx={{ display: "flex" }}>
			<Navigation />
			<Box sx={{ flexGrow: 1 }}>
				<main>
					<Box>
						<Outlet />
					</Box>
				</main>
			</Box>
			{/* <footer><Footer /></footer> */}
		</Box>
	);
}

export default Layout;
